// extracted by mini-css-extract-plugin
export var container = "MobileMenu-module--container--G1EMf";
export var header = "MobileMenu-module--header--1h2c8";
export var list = "MobileMenu-module--list--1vq8Z";
export var button = "MobileMenu-module--button--2KhpJ";